import React from 'react';
import { FaIcon } from '../util/FaIcon';
import { AcButton } from '../button/AcButton';
// https://react-bootstrap.github.io/components/dropdowns/#custom-dropdown-components
export const AcDropdownToggle = React.forwardRef((props, ref) => {
    const { onClick, disableDropdownIcon, toggleSize, toggleClassName, children, variant, active, disabled, readOnly, } = props;
    const handleClick = (e) => {
        e.preventDefault();
        if (onClick) {
            onClick(e);
        }
    };
    return (React.createElement(AcButton, { block: true, ref: ref, onClick: handleClick, size: toggleSize, className: toggleClassName, variant: variant, active: active, disabled: disabled || readOnly },
        React.createElement("div", { className: "d-flex align-items-center justify-content-between flex-nowrap min-width-0" },
            React.createElement("div", { className: "min-width-0 text-truncate" }, children),
            !disableDropdownIcon && (React.createElement(FaIcon, { icon: "fas fa-caret-down", className: `${toggleSize === 'sm' ? 'ml-1' : 'ml-3'}`, size: "default" })))));
});
AcDropdownToggle.displayName = 'AcDropdownToggle';
